export const menuData = [
  {
    name: "tiles",
    subMenu: [
      {
        name: "Location",
        lastMenu: [
          {
            imgSrc: "img_1.jpg",
            title: "Living Room Tiles",
          },
          {
            imgSrc: "img_2.jpg",
            title: "Bathroom Tiles",
          },
          {
            imgSrc: "img_3.jpg",
            title: "Bedroom Tiles",
          },
          {
            imgSrc: "img_4.jpg",
            title: "Kitchen Tiles",
          },
          {
            imgSrc: "img_5.jpg",
            title: "Outdoor Tiles",
          },
          {
            imgSrc: "img_6.jpg",
            title: "Balcony Tiles",
          },
          {
            imgSrc: "img_7.jpg",
            title: "Staircase Tiles",
          },
          {
            imgSrc: "img_8.jpg",
            title: "Elevation Tiles",
          },
          {
            imgSrc: "img_9.jpg",
            title: "Commercial Tiles",
          },
        ],
      },
      {
        name: "Look & Feel",
        lastMenu: [
          {
            imgSrc: "img_5.jpg",
            title: "Living Room Tiles",
          },
          {
            imgSrc: "img_4.jpg",
            title: "Bathroom Tiles",
          },
          {
            imgSrc: "img_3.jpg",
            title: "Bedroom Tiles",
          },
          {
            imgSrc: "img_2.jpg",
            title: "Kitchen Tiles",
          },
          {
            imgSrc: "img_1.jpg",
            title: "Outdoor Tiles",
          },
        ],
      },
      {
        name: "Color",
        lastMenu: [
          {
            imgSrc: "img_3.jpg",
            title: "Living Room Tiles",
          },
          {
            imgSrc: "img_2.jpg",
            title: "Bathroom Tiles",
          },
          {
            imgSrc: "img_1.jpg",
            title: "Bedroom Tiles",
          },
          {
            imgSrc: "img_5.jpg",
            title: "Kitchen Tiles",
          },
          {
            imgSrc: "img_4.jpg",
            title: "Outdoor Tiles",
          },
        ],
      },
      {
        name: "Collection",
        lastMenu: [
          {
            imgSrc: "img_1.jpg",
            title: "Living Room Tiles",
          },
          {
            imgSrc: "img_5.jpg",
            title: "Bathroom Tiles",
          },
          {
            imgSrc: "img_4.jpg",
            title: "Bedroom Tiles",
          },
          {
            imgSrc: "img_2.jpg",
            title: "Kitchen Tiles",
          },
          {
            imgSrc: "img_3.jpg",
            title: "Outdoor Tiles",
          },
        ],
      },
    ],
  },

  {
    name: "The Top",
    subMenu: [
      {
        name: "Lorem Ipsum 1",
        lastMenu: [],
      },
      {
        name: "Lorem Ipsum 2",
        lastMenu: [],
      },
      {
        name: "Lorem Ipsum 3",
        lastMenu: [],
      },
      {
        name: "Lorem Ipsum 4",
        lastMenu: [],
      },
    ],
  },

  {
    name: "Bathware",
    subMenu: [
      {
        name: "",
        lastMenu: [
          {
            imgSrc: "img_1.jpg",
            title: "EWC & Pan",
          },
          {
            imgSrc: "img_2.jpg",
            title: "Urinals",
          },
          {
            imgSrc: "img_3.jpg",
            title: "Basins",
          },
          {
            imgSrc: "img_4.jpg",
            title: "Kitchen Sink",
          },
          {
            imgSrc: "img_5.jpg",
            title: "Cistern",
          },
          {
            imgSrc: "img_6.jpg",
            title: "Accessories",
          },
        ],
      },
    ],
  },

  {
    name: "Digital Visualizer",
    subMenu: [
      {
        name: "Lorem Ipsum",
        lastMenu: [],
      },
      {
        name: "Lorem Ipsum",
        lastMenu: [],
      },
      {
        name: "Lorem Ipsum",
        lastMenu: [],
      },
      {
        name: "Lorem Ipsum",
        lastMenu: [],
      },
    ],
  },

  {
    name: "Projects",
    subMenu: [
      {
        name: "Location",
        lastMenu: [
          {
            imgSrc: "img_1.jpg",
            title: "Living Room Tiles",
          },
          {
            imgSrc: "img_2.jpg",
            title: "Bathroom Tiles",
          },
          {
            imgSrc: "img_3.jpg",
            title: "Bedroom Tiles",
          },
          {
            imgSrc: "img_4.jpg",
            title: "Kitchen Tiles",
          },
          {
            imgSrc: "img_5.jpg",
            title: "Outdoor Tiles",
          },
          {
            imgSrc: "img_6.jpg",
            title: "Balcony Tiles",
          },
          {
            imgSrc: "img_7.jpg",
            title: "Staircase Tiles",
          },
          {
            imgSrc: "img_8.jpg",
            title: "Elevation Tiles",
          },
          {
            imgSrc: "img_9.jpg",
            title: "Commercial Tiles",
          },
        ],
      },
    ],
  },

  {
    name: "Simpolo Solution",
    subMenu: [],
  },
  {
    name: "Catalogues",
    subMenu: [],
  },
  {
    name: "Professional",
    subMenu: [],
  },
  {
    name: "Contact us",
    subMenu: [
      {
        name: "Become a Dealer",
        lastMenu: [],
      },
      {
        name: "Enquiry",
        lastMenu: [],
      },
      {
        name: "Customer Complaints",
        lastMenu: [],
      },
      {
        name: "Work With Us",
        lastMenu: [],
      },
    ],
  },
];
